$(function() {

	var searchparams = new URLSearchParams(window.location.search);
	
	$("#headermenu .headermenu-addfriend").click(function(event){
		$.post("/friendsapi/friendrequest", {
			"action": "outsend", 
			"uid": searchparams.get("uid")
		}, function(obj){
			var errormessage;
			
			if( !obj ){
				errormessage = "no response received";
			}
			
			if( obj["res"] == "ok" ){
				alert("Friend request sent - they will appear in your Friends list once they have accepted your request");
				
				return;
			} else {
				if( obj["error"] == "alreadyinlist" ){
					alert("Already friends");
					
					return;
				} else if( obj["error"] == "requestduplicate" ){
					alert("Request is pending");
					
					return;
				} else if( obj["error"] == "self" ){
					alert("You cannot add yourself as a friend");
					
					return;
				}
			}
			
			alert(errormessage ? "error: " + errormessage : "error");
		}, "json");
	});

});
